import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'
import App from './App'
import './index.css'

// Sentry error monitoring
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
    // Don't send errors in development
    enabled: process.env.NODE_ENV === 'production',
  })
}

posthog.init('phc_DMrx8BKcxIRHaeYLl6cqboWYemobjeKYadKwk4F6SZr', {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
  capture_pageleave: true,
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: '2rem', fontFamily: 'monospace', fontSize: '0.85rem' }}>Something went wrong. The error has been reported.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
